export const sanitizeHtml = (string: string | null) => {
    const parser = new DOMParser();

    if (string) {
        const doc = parser.parseFromString(string, 'text/html');

        const plainText = doc.body?.textContent || '';

        return plainText;
    }

    return '';
};
